import { belgeDugmeleri } from "../components/receipts.js";
import { hatirlatmaSekmesi } from "../components/reminders.js";
import { hatirlatmaOzeti } from "../domain/reminders.js";
import { PAY, card, emptyNote } from "../components/ui.js";
import { B, cls, stu } from "../domain/context.js";
import { acikFaturalar, faturaDurumu, faturaTutari, tahsilEdilen, totalPaid } from "../domain/invoices.js";
import { avatar } from "../lib/avatar.js";
import { donemAdi, esc, fmtDate, money } from "../lib/fmt.js";
import { feeFor } from "../domain/fees.js";
import { state } from "../state.js";

// ---------- ÖDEMELER ----------
export function viewOdemeler() {
  const aktif = state.odemeTab ?? "faturalar";
  const sekmeler = `
  <div class="flex items-center gap-1 rounded-xl bg-line/50 p-1 mb-4 w-fit">
    ${[["faturalar", "Faturalar"], ["hatirlatma", `Hatırlatmalar${hatirlatmaOzeti(B().id).bekleyenHatirlatma ? ` · ${hatirlatmaOzeti(B().id).bekleyenHatirlatma}` : ""}`]]
      .map(([id, label]) => `
      <button data-odemetab="${id}"
        class="rounded-lg px-3 py-1.5 text-xs font-semibold whitespace-nowrap transition ${aktif === id ? "bg-white shadow-card" : "text-inksoft hover:text-ink"}">
        ${label}
      </button>`).join("")}
  </div>`;

  if (aktif === "hatirlatma") return sekmeler + hatirlatmaSekmesi(B().id);
  return sekmeler + faturaSekmesi();
}

function faturaSekmesi() {
  const t = B();
  const acik = acikFaturalar(t);
  const byStatus = k => acik.filter(p => faturaDurumu(stu(p.studentId), p) === k);
  const list = state.payFilter === "all" ? acik : byStatus(state.payFilter);

  const filters = [
    ["all", "Tümü", acik.length],
    ["gecikti", "Geciken", byStatus("gecikti").length],
    ["bekliyor", "Bekleyen", byStatus("bekliyor").length],
    ["kismi", "Kısmi", byStatus("kismi").length],
    ["odendi", "Ödenen", byStatus("odendi").length],
  ].filter(([, , n], i) => i === 0 || n > 0);

  const kalan = l => l.reduce((a, p) => a + faturaTutari(stu(p.studentId), p) - tahsilEdilen(p), 0);

  return `
  <div class="grid gap-3 sm:gap-4 grid-cols-2 sm:grid-cols-3 mb-4">
    ${card(`
      <div class="p-4">
        <div class="text-xs font-semibold text-inksoft">Tahsil Edilen</div>
        <div class="font-display font-extrabold text-2xl mt-1 text-teal">${money(totalPaid(acik))}</div>
        <div class="text-[11px] text-inksoft mt-0.5">${byStatus("odendi").length} fatura kapandı</div>
      </div>`, "min-w-0")}
    ${card(`
      <div class="p-4">
        <div class="text-xs font-semibold text-inksoft">Bekleyen</div>
        <div class="font-display font-extrabold text-2xl mt-1 text-[#B07E14]">${money(kalan([...byStatus("bekliyor"), ...byStatus("kismi")]))}</div>
        <div class="text-[11px] text-inksoft mt-0.5">${byStatus("bekliyor").length + byStatus("kismi").length} fatura</div>
      </div>`, "min-w-0")}
    ${card(`
      <div class="p-4">
        <div class="text-xs font-semibold text-inksoft">Geciken</div>
        <div class="font-display font-extrabold text-2xl mt-1 text-coral">${money(kalan(byStatus("gecikti")))}</div>
        <div class="text-[11px] text-inksoft mt-0.5">${byStatus("gecikti").length} fatura · vadesi geçti</div>
      </div>`, "min-w-0")}
  </div>

  ${card(`
    <div class="p-4 border-b border-line">
      <div class="flex items-center justify-between gap-3 flex-wrap">
        <h2 class="font-display font-bold text-base">Sınıf Bazlı Aylık Ücretler</h2>
        <span class="text-[11px] text-inksoft">Servis ${money(t.serviceFee)} / ay · indirimler toplam üzerinden</span>
      </div>
      <div class="flex gap-2 overflow-x-auto mt-3 pb-1">
        ${t.classes.map(c => `
          <div class="min-w-[150px] flex-1 rounded-xl border border-line p-3" style="border-left:3px solid ${c.color}">
            <div class="text-sm font-semibold">${esc(c.name)}</div>
            <div class="text-[11px] text-inksoft">${c.age}</div>
            <div class="mt-2 text-sm font-bold">${money(c.tuition)}<span class="text-[10px] font-normal text-inksoft"> / tam gün</span></div>
            <div class="text-xs text-inksoft">${money(c.tuitionHalf)}<span class="text-[10px]"> / yarım gün</span></div>
          </div>`).join("")}
      </div>
    </div>

    <div class="p-4 border-b border-line flex gap-1.5 flex-wrap">
      ${filters.map(([k, label, n]) => `
        <button data-payfilter="${k}" class="text-xs font-semibold rounded-full px-3 py-1.5 border transition
          ${state.payFilter === k ? "bg-ink text-white border-ink" : "bg-card border-line text-inksoft hover:border-ink/40"}">
          ${label} <span class="opacity-60">${n}</span></button>`).join("")}
    </div>

    <div class="overflow-x-auto">
      <table class="w-full text-sm min-w-[920px]">
        <thead>
          <tr class="text-left text-[11px] uppercase tracking-wide text-inksoft border-b border-line whitespace-nowrap">
            <th class="px-5 py-3">Öğrenci</th><th class="px-5 py-3">Dönem</th>
            <th class="px-5 py-3">Ücret Dökümü</th><th class="px-5 py-3">Tutar</th>
            <th class="px-5 py-3">Son Ödeme</th><th class="px-5 py-3">Durum</th><th class="px-5 py-3">Belge</th><th class="px-5 py-3 text-right">İşlem</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-line/70">
          ${list.map(p => {
            const s = stu(p.studentId);
            const f = feeFor(s, p);
            const tutar = faturaTutari(s, p);
            const odenen = tahsilEdilen(p);
            const durum = faturaDurumu(s, p);
            const m = PAY[durum];
            const sonHareket = p.transactions.at(-1);
            const parts = [
              `${money(f.base)}<span class="text-inksoft"> ${f.half ? "yarım gün" : "tam gün"}</span>`,
              f.service ? `+ ${money(f.service)}<span class="text-inksoft"> servis</span>` : "",
              f.discount ? `<span class="text-teal">− ${money(f.discount)} ${esc(f.discountLabel)} %${f.pct}</span>` : "",
            ].filter(Boolean);
            return `<tr class="hover:bg-paper/60">
              <td class="px-5 py-3 whitespace-nowrap">
                <span class="inline-flex items-center gap-2.5">${avatar(s, "w-8 h-8 text-[10px]")}
                  <span><span class="block font-semibold">${esc(s.name)}</span>
                  <span class="block text-[11px] text-inksoft">${esc(cls(s.classId).name)}</span></span></span></td>
              <td class="px-5 py-3 text-inksoft whitespace-nowrap">${donemAdi(p.period)}${p.note ? `<span class="block text-[10px] text-inksoft/70">${esc(p.note)}</span>` : ""}</td>
              <td class="px-5 py-3 text-[11px] leading-relaxed whitespace-nowrap">${parts.join("<br>")}
                ${f.override !== null ? `<span class="block text-[10px] text-grape font-semibold">Özel tutar uygulandı</span>` : ""}</td>
              <td class="px-5 py-3 font-semibold whitespace-nowrap">${money(tutar)}
                ${durum === "kismi" ? `<span class="block text-[10px] font-normal text-sky">${money(odenen)} tahsil · ${money(tutar - odenen)} kaldı</span>` : ""}</td>
              <td class="px-5 py-3 text-inksoft whitespace-nowrap">${fmtDate(p.due)}${sonHareket ? `<span class="block text-[10px] text-teal">${fmtDate(sonHareket.date)} · ${esc(sonHareket.method)}</span>` : ""}</td>
              <td class="px-5 py-3"><span class="text-[11px] font-bold rounded-full px-2.5 py-1 ${m.chip}">${m.label}</span></td>
              <td class="px-5 py-3 text-right">${durum !== "odendi"
                ? `<button class="text-xs font-semibold text-teal hover:underline" onclick="alert('Demo: hatırlatma SMS/e-posta gönderildi (mock).')">Hatırlat</button>`
                : `<span class="text-xs text-inksoft/50">${esc(sonHareket?.receiptNo ?? "Makbuz")}</span>`}</td>
            <td class="py-3">${belgeDugmeleri(s, p, B().id, { kalan: tutar - odenen })}</td>
            </tr>`;
          }).join("") || `<tr><td colspan="7">${emptyNote("Bu durumda kayıt yok.")}</td></tr>`}
        </tbody>
      </table>
    </div>`)}`;
}

